import RestClient from '../../../lib/RestClient';

const URL = '/temporary/';

class TempdataService {

    public featureSwitches : any = {};
    public tourendatenText : any = {};


    constructor() {
        this.getFeatureSwitches();
        this.getTourdatentext();
    }

    public getFeatureSwitches() {
        RestClient.get(URL + "feature-switch").then(
            (response) => {
                this.featureSwitches = response.data.data;

            }
        );
    }

    public getTourdatentext() {
        RestClient.get(URL + "tourdata-text").then(
            (response) => {
                this.tourendatenText = response.data.data;
            }
        );
    }
}

const TempdataServiceInstance = new TempdataService();
export default TempdataServiceInstance;